export const EVENT = 'App\\Models\\ResourcePlanning\\TaskEvent';
export const SUBSCRIPTION = 'App\\Models\\Subscription\\Subscription';
export const CONTRACTS = 'App\\Models\\BuildingComplex\\Contract';

export default Object.freeze({
  EVENT,
  SUBSCRIPTION,
  CONTRACTS
});
